import Image from "next/image";
import { ReactNode } from "react";
import { ALERT_TYPES } from "rivals/components/app/Layout/Header/AccountLinks/types";
import AlertArrows from "rivals/components/shared/Icons/AlertArrows";
import AlertBell from "rivals/components/shared/Icons/AlertBell";
import AlertCheckmark from "rivals/components/shared/Icons/AlertCheckmark";
import AlertHat from "rivals/components/shared/Icons/AlertHat";
import AlertNewspaper from "rivals/components/shared/Icons/AlertNewspaper";
import Decommit from "rivals/components/shared/Icons/Decommit";
import SchoolVisit from "rivals/components/shared/Icons/SchoolVisit";
import Withdraw from "rivals/components/shared/Icons/Withdraw";
import commonStyles from "rivals/styles/exports.module.scss";
import styles from "./UserAlertIcon.module.scss";
import type { Props } from "./types";

const contentAlertIconMap: { [index: string]: ReactNode } = {
  [ALERT_TYPES.Alert]: <AlertBell />,
  [ALERT_TYPES.Article]: <AlertNewspaper />,
  [ALERT_TYPES.Decommitment]: <Decommit />,
  [ALERT_TYPES.EntersTransferPortal]: (
    <AlertArrows
      fill={commonStyles.brownTumbleweed}
      fillBg={commonStyles.corn}
    />
  ),
  [ALERT_TYPES.IntendsToEnterTransferPortal]: (
    <AlertArrows fillBg={commonStyles.darkSkyBlue} />
  ),
  [ALERT_TYPES.OfficialSchoolVisit]: <SchoolVisit />,
  [ALERT_TYPES.SchoolOffer]: <AlertHat />,
  [ALERT_TYPES.Signed]: (
    <AlertCheckmark fill={commonStyles.white} fillBg={commonStyles.pass} />
  ),
  [ALERT_TYPES.SoftVerbalCommitment]: (
    <AlertCheckmark fill={commonStyles.white} fillBg={commonStyles.gray60} />
  ),
  [ALERT_TYPES.Transfer]: <AlertArrows />,
  [ALERT_TYPES.UnofficialSchoolVisit]: (
    <SchoolVisit fill={commonStyles.gray60} />
  ),
  [ALERT_TYPES.VerbalCommitment]: <AlertCheckmark />,
  [ALERT_TYPES.WithdrawsFromTransferPortal]: <Withdraw />
};

const UserAlertIcon = ({
  userAlert: { alertSource, alertType, avatarUrl, username }
}: Props): ReactNode => {
  if (alertSource === "forums") {
    if (!username) {
      return null;
    }

    if (avatarUrl) {
      return (
        <Image
          alt={username}
          className={styles.userAlertIconAvatarImage}
          height={24}
          src={avatarUrl}
          width={24}
        />
      );
    } else {
      return (
        <div className={styles.userAlertIconAvatarIcon}>
          {username.charAt(0)}
        </div>
      );
    }
  } else {
    return contentAlertIconMap[alertType];
  }
};

export default UserAlertIcon;
